import { InjectionToken } from '@angular/core';

/**
 * Resolves the current user's companyId for contract-actions flows.
 *
 * The ui-kit cannot import `@finverity/authentication` (would create a
 * library cycle), so every app that uses contract-actions registers this
 * token with a factory backed by its own auth facade.
 */
export const CONTRACT_ACTIONS_CURRENT_COMPANY_ID = new InjectionToken<() => string | null>(
  '[CONTRACT_ACTIONS_CURRENT_COMPANY_ID]'
);
